module.exports = __webpack_public_path__ + "images/email-88b480625fd4344117cb1417c4851268.png";